import styles from "./UndoToast.module.scss";

interface IUndoToastProps {
  message: string;
  undoLabel: string;
  onUndo: () => void;
}

/** A toast body with a message and one action that takes the change back. */
export const UndoToast = ({ message, undoLabel, onUndo }: IUndoToastProps) => {
  return (
    <div className={styles.root} role="status">
      <span className={styles.message}>{message}</span>
      <button type="button" className={styles.undo} onClick={onUndo}>
        {undoLabel}
      </button>
    </div>
  );
};
